// extracted by mini-css-extract-plugin
export var container = "_b1-0";
export var icon = "_b1-1";
export var text = "_b1-2";